import { store } from 'react-notifications-component';
export const errorResponse = (payload) => {
    var response = {status : 500, message: 'Something Went Wrong, Please Try After Some Time'};
    try {
      const { error, alert_error } = payload;
      if(typeof error.response !== "undefined"
          && typeof error.response.data !== "undefined"
      ){
          if(typeof error.response.data.message !== "undefined"){
              response.message = error.response.data.message;
          }
  
          if(typeof error.response.status !== "undefined"){
              response.status = error.response.status;
              // console.log(error.response.status, 'error.response.status')
              if(error.response.status === 404){
                response.message = 'Not Found';
              }else if(error.response.status === 500){
                response.message = 'Internal Error';
              }
          }
      }
      if(alert_error === 1){
          alertResponseMessage({alert_type: 2, message: response.message});
      }
      return response;
    } catch (e) {
      return response;
    }
  };
  
  export const alertResponseMessage = (payload) => {
      try {
        const { alert_type } = payload;
        const title = payload.title || "";
        const isCustom = payload.custom || "";
        const message = payload.message || "";
        const notifyType = {
          1: 'success',
          2: 'danger',
          4: 'info',
          3: 'warning'
        };
        var notiData = {
          title,
          message,
          type: notifyType[alert_type],
          insert: "top",
          // container: "bottom-center",
          container: "center",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            // onScreen: true
          }
        };
        //alert_type: 1=>success, 2=> error, 3=> warning
        if(isCustom
          && isCustom === 'image'
        ){
          notiData.content = <CustomImgNotification image={payload.image} custom_msg={payload.custom_msg}/>
        }
        store.addNotification(notiData);
        // alert(message);//Replace with Custom UI
      } catch (e) {
      //   return response;
      }
  };

  function CustomImgNotification({ image,  custom_msg}) {
    return <div className="animate__animated animate__fadeIn notification__item notification__item--info mb-0">
              <div className="notification__content">
                <div className="notification__message">
                  <div className="d-flex">
                    <img src={image} alt="i-icon" className="sm-icon-50"/>&nbsp;
                    <span dangerouslySetInnerHTML={ { __html: custom_msg}}></span>
                  </div>
                </div>
              </div>
            </div>;
  }

  export const alertNotification = (payload) => {
    try {
      const { message } = payload;
      const title = payload.title || "";
      store.addNotification({
        title,
        message,
        type: 'info',
        insert: "top",
        container: "bottom-left",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 7000,
          // onScreen: true
        }
      });
      // alert(message);//Replace with Custom UI
    } catch (e) {
    //   return response;
    }
};
  